function isPrimitive(value: unknown): value is string | number | boolean | null {
    return (
        value === null ||
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
    );
}

function isPrimitiveArray(value: unknown): value is (string | number | boolean | null)[] {
    return Array.isArray(value) && value.every((item) => isPrimitive(item));
}

function isPrimitiveOrPrimitiveArray(value: unknown): boolean {
    return isPrimitive(value) || isPrimitiveArray(value);
}

function isCompactObject(obj: Record<string, unknown>): boolean {
    const entries = Object.entries(obj).filter(([, item]) => item !== undefined);
    return entries.length > 0 && entries.every(([, item]) => isPrimitiveOrPrimitiveArray(item));
}

function isAllPrimitiveObject(obj: Record<string, unknown>): boolean {
    const entries = Object.entries(obj).filter(([, item]) => item !== undefined);
    return entries.length > 0 && entries.every(([, item]) => isPrimitive(item));
}

function stringifyInner(value: unknown, indent: number): string {
    if (value === null) {
        return 'null';
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return JSON.stringify(value);
    }
    if (typeof value === 'string') {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        if (isPrimitiveArray(value)) {
            return `[${value.map((item) => stringifyInner(item, indent)).join(', ')}]`;
        }
        const pad = ' '.repeat(indent);
        const childPad = ' '.repeat(indent + 2);
        const items = value.map((item) => `${childPad}${stringifyInner(item, indent + 2)}`);
        return `[\n${items.join(',\n')}\n${pad}]`;
    }
    if (typeof value === 'object') {
        const obj = value as Record<string, unknown>;
        const entries = Object.entries(obj).filter(([, item]) => item !== undefined);
        if (entries.length === 0) {
            return '{}';
        }
        if (isAllPrimitiveObject(obj)) {
            const props = entries.map(
                ([key, item]) => `${JSON.stringify(key)}: ${stringifyInner(item, 0)}`,
            );
            return `{ ${props.join(', ')} }`;
        }
        if (isCompactObject(obj)) {
            const props = entries.map(
                ([key, item]) => `${JSON.stringify(key)}: ${stringifyInner(item, 0)}`,
            );
            return `{ ${props.join(', ')} }`;
        }
        const pad = ' '.repeat(indent);
        const childPad = ' '.repeat(indent + 2);
        const props = entries.map(
            ([key, item]) => `${childPad}${JSON.stringify(key)}: ${stringifyInner(item, indent + 2)}`,
        );
        return `{\n${props.join(',\n')}\n${pad}}`;
    }
    return JSON.stringify(value);
}

export function stringifyCaseFile(value: unknown): string {
    return `${stringifyInner(value, 0)}\n`;
}
